export const Tabs = {
  design: {
    pattern: 'Pattern',
    collar: 'Collar',
  },
  logos: {
    sponsor: 'Sponsors logo',
  },
  name: {
    naming: 'Naming',
    specs: 'Specs',
  },
};
export const MobileTabs = {
  design: {
    pattern: 'Pattern',
    collar: 'Collar',
  },
  logos: {
    sponsor: 'Sponsors logo',
  },
  name: {
    naming: 'Naming',
    size: 'Size',
    specs: 'Specs',
  },
  submit: {
    save: 'Save Project',
  },
};
export const MouseTabs = {
  design: {
    pattern: 'Pattern',
    surface: 'Surface',
    size: 'Size',
  },
  logos: {
    image: 'Image',
    additional_images: 'Additional Images',
  },
  name: {
    specs: 'Specs',
  },
};
export const MobileTabsMouse = {
  design: {
    pattern: 'Pattern',
    collar: 'Collar',
    surface: 'Surface',
    size: 'Size',
  },
  logos: {
    sponsor: 'Sponsors logo',
    image: 'Image',
    additional_images: 'Additional Images',
  },
  name: {
    specs: 'Specs',
  },
  submit: {
    save: 'Save Project',
  },
};